import React, { useContext } from 'react';
import { Badge } from 'antd';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';
import AmazonWebServicesTable from '@totem/components/administration/amazonWebServices/AmazonWebServicesTable';
import AssignHierarchyModal from '@totem/components/administration/amazonWebServices/AssignHierarchyModal';
import AssignSalesOrderModal from '@totem/components/administration/amazonWebServices/AssignSalesOrderModal';
import DeleteInstanceModal from '@totem/components/administration/amazonWebServices/DeleteInstanceModal';
import { AwsInstanceRecord } from '@totem/components/administration/amazonWebServices/types';
import UpdateStatusModal from '@totem/components/administration/amazonWebServices/UpdateStatusModal';

// Not tied to a delivered service AND not already explicitly triaged as
// "Overhead" or "Development" — those two statuses mean a person already
// looked at the instance and confirmed it isn't meant to carry a sales
// order, so they shouldn't keep showing up on a commissioning worklist.
const unassigned = (record: AwsInstanceRecord) =>
  record.item.salesOrders.length === 0 &&
  record.status !== 'Overhead' &&
  record.status !== 'Development';

export const AwsCommissioningExtra = () => {
  const { data } = useContext(AmazonWebServicesContext);
  const unassignedCount = data.filter(unassigned).length;

  return (
    <Badge count={unassignedCount} overflowCount={9999} offset={[0, -7]}>
      AWS&nbsp;&nbsp;
    </Badge>
  );
};

const AwsCommissioningLayout = () => (
  <>
    <AmazonWebServicesTable filterPredicate={unassigned} />
    <AssignHierarchyModal />
    <AssignSalesOrderModal />
    <UpdateStatusModal />
    <DeleteInstanceModal />
  </>
);

export default AwsCommissioningLayout;
